import React from 'react';
import { Table } from 'semantic-ui/semantic-ui-imports';
import { useTranslation } from 'react-i18next';
import { useData } from '../../contexts/data';
import { AggregateCategory } from '../../Types/Aggregates';
import AggregateCalcuation from '../AggregateCalculation';

interface Props {
  categories?: AggregateCategory[];
}

const AggregateTableRow = ({ categories }: Props) => {
  const { activeAggregate } = useData();
  const { t } = useTranslation();

  return (
    <>
      {activeAggregate && (
        <Table basic attached="top" padded>
          <Table.Header>
            <Table.Row key="product-table-header">
              {categories &&
                categories.map((cat) => (
                  <Table.HeaderCell key={`product-cat-${cat.key}`}>
                    <span>{t(`productPage.tableHeaders.${cat.name}`)}</span>
                  </Table.HeaderCell>
                ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <AggregateCalcuation
              aggregate={activeAggregate}
              categories={categories}
              key={activeAggregate.id}
            />
          </Table.Body>
        </Table>
      )}
    </>
  );
};

AggregateTableRow.defaultProps = {
  categories: [],
};

export default AggregateTableRow;
